import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../_common/Loader/Loader';
import classes from '../physicians.module.scss';
import Pagination from '../../../_common/Pagination/Pagination';

const PhysiciansTable = ({
  data, header, page, limit, totalPage, onChange, health, loading,
}) => {
  const navigate = useNavigate();

  return (
    !data.length
      ? (
        <div className={classes.notResult}>
          { loading && <Loader />}

          No Data Found
        </div>
      )

      : (
        <div className={classes.table_pagination_wrapper}>
          { loading && <Loader />}

          <div className={classes.table_wrapper}>
            <table>
              <thead>
                <tr>
                  {header.map((h) => (
                    <th key={h.name}>{h.name}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {data.map((d) => {
                  const address = _.compact([d.addressStreet, d.addressCity, d.addressState, d.addressZipCode]);
                  return (
                    <tr key={d.id} onClick={() => navigate(!health ? `${d.id}` : `${d.id}?hubId=${d.hubId}`)}>
                      {header.map((h) => (
                        h.path === 'name'
                          ? <td key={h.name}>{health ? d.name : `${d?.firstName} ${d?.lastName} `}</td>
                          : h.path === 'rep' && health
                            ? <td key={h.name}>{d?.Representative?.name ? d?.Representative?.name : '-'}</td>
                            : h.path === 'address'
                              ? (
                                  <td key={h.name}>
                                    {(!_.isEmpty(address)) ? address.join(', ') : '-'}
                                  </td>
                              )
                              : <td key={h.name}>{d[h.path] ? d[h.path] : '-'}</td>
                      ))}

                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <Pagination page={page} limit={limit} totalPage={totalPage} onChange={onChange} />
        </div>
      )
  );
};

PhysiciansTable.propTypes = {
  data: PropTypes.array.isRequired,
  header: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  totalPage: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  health: PropTypes.bool,
};

PhysiciansTable.defaultProp = {
  health: false,
};

export default PhysiciansTable;
